import React, { useMemo } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Pane from 'components/Common/Pane'
import LayoutContainer from 'components/Common/LayoutContainer'
import Heading from 'LuxKit/Typography/Heading'
import ValuePropositionItems from 'home/components/ValuePropositionBanner/ValuePropositionItems'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import { getHotelValueContentSection } from './getHotelValueContentSection'

const StyledLayoutContainer = styled(LayoutContainer)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

function HotelValuePropositionBanner() {
  const values = useMemo(() => getHotelValueContentSection().filter(value => value.show), [])
  return (<Pane>
    <StyledLayoutContainer>
      <VerticalSpacer gap={20}>
        <Heading variant="heading2">Why you should book with us</Heading>
        <ValuePropositionItems values={values} />
      </VerticalSpacer>
    </StyledLayoutContainer>
  </Pane>)
}

export default React.memo(HotelValuePropositionBanner)
